import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { copyToClipboard } from './copyToClipboard'

type DoCopyAsync = (url: string) => Promise<void>

const CopyPropTypes = {
  buttonLabel: PropTypes.node.isRequired,
  copyText: PropTypes.string.isRequired,
  className: PropTypes.string
}

type CopyProps = PropTypes.InferProps<typeof CopyPropTypes>

const delay: (t: number) => Promise<void> = async (t: number) => await new Promise(resolve => setTimeout(resolve, t))

export const CopyButton: React.FC<CopyProps> = ({ buttonLabel, copyText, className }) => {
  const additionalClasses = className ?? ''

  const [isCopying, setIsCopying] = useState(false)

  const currentButtonLabel = (isActive: boolean): PropTypes.ReactNodeLike => isActive ? 'COPIED!!' : buttonLabel

  // function structure is due to eslint recommendation:
  // https://github.com/typescript-eslint/typescript-eslint/blob/main/packages/eslint-plugin/docs/rules/no-misused-promises.md#checksvoidreturn-true
  const doCopyAsync: DoCopyAsync = async (copyText: string) => {
    const handler: () => Promise<void> = async () => {
      await copyToClipboard(copyText)
      await delay(750)
      setIsCopying(false)
    }

    try {
      setIsCopying(true)
    } catch (e) {
      console.error(e)
    }

    handler().catch((e) => console.error(e))
  }

  return (
    // The onClick handler catches to avoid no-misused-promises linting error
    <button
      id='copy-button'
      className={`button ${additionalClasses}`}
      onClick={() => { doCopyAsync(copyText).catch((e) => console.error(e)) }}
      disabled={isCopying}
    >
      {currentButtonLabel(isCopying) as React.ReactNode}
    </button>
  )
}
